/* eslint-disable no-console */
import { createAccount, updateAccount } from '../consumer-account/account-api';
import { checkLoginStatus } from '../consumer-account/login';
import { validate, validateByType, positionWindowAtFormElement, formatPhone } from '../../utils/form-validation-utils';

const registrationInfo = () => {
  // Check for user id in session storage
  const { userId } = window;
  let sessionUserId = userId;
  let isExistingAccount = false;
  if (!isNaN(sessionUserId)) { /* eslint-disable-line no-restricted-globals */
    isExistingAccount = true;
  } else {
    const { sessionStorage } = window;
    const sessionObj = sessionStorage.getItem('bali_userId');
    if (sessionObj !== null) {
      sessionUserId = JSON.parse(sessionObj).userId;
      isExistingAccount = true;
    }
  }
  // console.log(`sessionUserId: ${sessionUserId}`);
  // console.log(`isExistingAccount: ${isExistingAccount}`);

  const passwordMatch = (passIpt, passConfirmIpt) => {
    // Ignore if there's no password confirm field
    if (!passConfirmIpt || !passIpt) {
      return true;
    }
    if (passIpt.value === passConfirmIpt.value) {
      return true;
    }
    return false;
  };

  const passwordStrength = (passIpt, passConfirmIpt) => {
    // Ignore if there's no password confirm field
    if (!passConfirmIpt || !passIpt) {
      return true;
    }
    if (passIpt.value === '' && passConfirmIpt.value === '') {
      return true; // ignore
    }
    if (validateByType('password', passIpt.value) && validateByType('password', passConfirmIpt.value)) {
      return true;
    }
    return false;
  };

  const detectProduction = () => {
    const prodUrls = [
      'www.baliblinds.com',
      'https://baliblinds.com',
      'http://baliblinds.com',
    ];
    const { location } = window;
    const { href } = location;
    let isProd = false;
    prodUrls.forEach((url) => {
      if (href.indexOf(url) !== -1) {
        isProd = true;
      }
    });
    return isProd;
  };

  const scrollToPageTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const saveSessionData = (data) => {
    console.log(data);
    const form = document.querySelector('.pr-acct-create-form');
    const username = form.querySelector('[name="acctUsername"]');
    const { sessionStorage } = window;
    // If user id is returned, save to session storage
    if (data.userId !== '') {
      sessionStorage.setItem('bali_userId', JSON.stringify({ userId: data.userId }));
    }
    // Save all post-purchase lead data in session storage
    const tags = ['Post Purchase Program'];
    if (data.optInVal === 1) {
      tags.push('Opted In');
    }
    if (!detectProduction()) {
      tags.push('Dev');
    }
    sessionStorage.setItem('bali_ppData', JSON.stringify({
      email: username.value,
      first_name: document.getElementById('FirstName').value,
      last_name: document.getElementById('LastName').value,
      phone: formatPhone(document.getElementById('PhoneNumber').value),
      address1: document.getElementById('Address').value,
      address2: document.getElementById('Address2').value,
      city: document.getElementById('City').value,
      state: document.getElementById('StateOrProvince').value,
      zip: document.getElementById('PostalCode').value,
      country: document.getElementById('Country').value,
      source: 'website',
      tags,
    }));
  };

  const runCreateAccount = () => {
    const form = document.querySelector('.pr-acct-create-form');
    const username = form.querySelector('[name="acctUsername"]');
    const passIpt = form.querySelector('[name="acctPassword"]');
    const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
    const existingErrorMsg = form.querySelector('.existing-account-error-message');
    const serverErrorMsg = form.querySelector('.server-error-message');
    const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
    const isAddAccount = passConfirmIpt !== null || passIpt !== null;
    let optInVal = 0;
    if (form.querySelectorAll('[name="offer-opt-in"]').length !== 0) {
      const isChecked = form.querySelectorAll('[name="offer-opt-in"]:checked').length;
      if (isChecked === 1) {
        optInVal = 1;
      }
    }
    let password = '';
    if (passIpt !== null) {
      password = passIpt.value;
    }
    createAccount(
      {
        username: username.value,
        password,
        'marketing-opt-in': optInVal,
        'first-name': document.getElementById('FirstName').value,
        'last-name': document.getElementById('LastName').value,
        address: document.getElementById('Address').value,
        address2: document.getElementById('Address2').value,
        city: document.getElementById('City').value,
        'state-or-province': document.getElementById('StateOrProvince').value,
        'postal-code': document.getElementById('PostalCode').value,
        country: document.getElementById('Country').value,
        'phone-number': formatPhone(document.getElementById('PhoneNumber').value),
        'microsite-name': window.micrositeName,
      },
      {
        onSuccess: (data) => {
          console.log(data);
          if (data['user-id'] === 0 || data['user-id'] === '0') {
            existingErrorMsg.classList.remove('hide');
            scrollToPageTop();
          } else if (data['user-id'] === -1) {
            if (isAddAccount) {
              accountCreationErrorMsg.classList.remove('hide');
            } else {
              serverErrorMsg.classList.remove('hide');
            }
            scrollToPageTop();
          } else {
            saveSessionData({
              userId: data['user-id'],
              optInVal,
            });
            if (isAddAccount) {
              window.isAuthenticated = true;
              window.userId = data['user-id'];
              checkLoginStatus(() => {
                window.location = window.AddProductsUrl;
              });
            } else {
              window.location = window.AddProductsUrl;
            }
          }
        },
        onError: (data) => {
          console.log(data);
          serverErrorMsg.classList.remove('hide');
          scrollToPageTop();
        },
      },
    );
  };

  const runUpdateAccount = () => {
    // console.log('registratoin-info.js, runUpdateAccount');
    const form = document.querySelector('.pr-acct-create-form');
    const serverErrorMsg = form.querySelector('.server-error-message');
    let optInVal = 0;
    if (form.querySelectorAll('[name="offer-opt-in"]').length !== 0) {
      const isChecked = form.querySelectorAll('[name="offer-opt-in"]:checked').length;
      if (isChecked === 1) {
        optInVal = 1;
      }
    }
    updateAccount(
      {
        'user-id': sessionUserId,
        'marketing-opt-in': optInVal,
        'first-name': document.getElementById('FirstName').value,
        'last-name': document.getElementById('LastName').value,
        address: document.getElementById('Address').value,
        address2: document.getElementById('Address2').value,
        city: document.getElementById('City').value,
        'state-or-province': document.getElementById('StateOrProvince').value,
        'postal-code': document.getElementById('PostalCode').value,
        country: document.getElementById('Country').value,
        'phone-number': formatPhone(document.getElementById('PhoneNumber').value),
      },
      {
        onSuccess: (data) => {
          console.log(data);
          saveSessionData({
            userId: '',
            optInVal,
          });
          window.location = window.AddProductsUrl;
        },
        onError: (data) => {
          console.log(data);
          serverErrorMsg.classList.remove('hide');
          scrollToPageTop();
        },
      },
    );
  };

  if (document.querySelector('.pr-form') !== null) {
    const form = document.querySelector('.pr-acct-create-form');
    const updateBtn = form.querySelector('.o-form__update');
    const submitBtn = form.querySelector('.o-form__submit');
    // const username = form.querySelector('[name="acctUsername"]');
    const passIpt = form.querySelector('[name="acctPassword"]');
    const passConfirmIpt = form.querySelector('[name="acctPasswordConfirm"]');
    const serverErrorMsg = form.querySelector('.server-error-message');
    const mismatchErrorMsg = form.querySelector('.password-mismatch-error-message');
    const existingErrorMsg = form.querySelector('.existing-account-error-message');
    const accountCreationErrorMsg = form.querySelector('.account-creation-error-message');
    const passwordStrengthErrorMsg = form.querySelector('.password-strength-error-message');
    const isAddAccount = passConfirmIpt !== null || passIpt !== null;

    if (updateBtn) {
      updateBtn.addEventListener('click', (event) => {
        event.preventDefault();
        runUpdateAccount();
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (isAddAccount) {
          mismatchErrorMsg.classList.add('hide');
          accountCreationErrorMsg.classList.add('hide');
          passwordStrengthErrorMsg.classList.add('hide');
        }
        serverErrorMsg.classList.add('hide');
        existingErrorMsg.classList.add('hide');
        if (validate(form) && passwordMatch(passIpt, passConfirmIpt)) {
          if (isExistingAccount) {
            runUpdateAccount();
          } else {
            runCreateAccount();
          }
        } else if (!passwordMatch(passIpt, passConfirmIpt)) {
          passIpt.parentNode.classList.add('ValidationFail');
          passConfirmIpt.parentNode.classList.add('ValidationFail');
          mismatchErrorMsg.classList.remove('hide');
          positionWindowAtFormElement({
            element: form.parentNode,
            offset: -75,
          });
        } else {
          positionWindowAtFormElement({
            element: form.parentNode,
            offset: -75,
          });
          if (!passwordStrength(passIpt, passConfirmIpt)) {
            passwordStrengthErrorMsg.classList.remove('hide');
            scrollToPageTop();
          }
        }
      });
    }
  }
};
export default registrationInfo;
/* eslint-enable no-console */
